/**
 * Created by ren on 02/06/2017.
 */
import * as ActionType from '../constants/constant_action_types';
import { lists as Lists } from '../common/lists';

const INITIAL_STATE = {
  list: [],
  settings: {},
  preferences: {
    account: {},
    subsidiary: {},
    location: {},
  },
  isFetching: false,
};

export function preferenceReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionType.SET_PREFERENCES_CONTENT: {
      return {
        ...state,
        list: action.preferences,
        type: action.preference_type,
        type_id: action.type_id,
        isFetching: false,
      };
    }

    case ActionType.SET_PREFERENCE_SETTING: {
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.settings,
        },
      };
    }

    case ActionType.SET_ALL_PREFERENCE_SETTING: {
      const preferences = action.preferences;
      const lsaPreferences = assembleLSAPreferences(state.preferences, preferences);
      const accountPreferences = assembleAccountPreferences(
        Lists.PREFERENCE_SETTING(action.intl),
        lsaPreferences.account,
      );

      return {
        ...state,
        preferences: {
          account: accountPreferences,
          location: lsaPreferences.location,
          subsidiary: lsaPreferences.subsidiary,
        },
      };
    }

    case ActionType.SET_PREFERENCES_CONTENT_IN_PROGRESS: {
      return { ...state, isFetching: true };
    }

    default:
      return state;
  }
}

function assembleLSAPreferences(preferences, preferenceData = []) {
  return (preferenceData || []).reduce((newPreference, element) => {
    if (element.pref_type === 'location' || element.pref_type === 'subsidiary') {
      return {
        ...newPreference,
        [element.pref_type]: {
          ...newPreference[element.pref_type],
          [element.type_id]: {
            ...newPreference[element.pref_type][element.type_id],
            [element.setting]: {
              key: element.setting,
              type: element.setting_type,
              value: element.value,
            },
          },
        },
      };
    }

    return {
      ...newPreference,
      [element.pref_type]: {
        ...newPreference[element.pref_type],
        [element.setting]: {
          key: element.setting,
          type: element.setting_type,
          value: element.value,
        },
      },
    };
  }, preferences);
}

function assembleAccountPreferences(defaultPreferences = [], accountPreferences) {
  return defaultPreferences.reduce((newState, element) => {
    return {
      ...newState,
      [element.key]: {
        ...element,
        value: (accountPreferences[element.key] || {}).value,
      },
    };
  }, {});
}
